import React from "react";
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps,
} from "react-router-dom";
import { getToken } from "../../helpers/auth";
import { HOMEPAGE_PATH } from "../../constants/auth";

interface Props {
  renderComponent:
    | React.ComponentType<RouteComponentProps>
    | React.ComponentType;
}

const ProtectedRoute: React.FC<Props & RouteProps> = ({
  renderComponent: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      !getToken() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: HOMEPAGE_PATH }} />
      )
    }
  />
);

export default ProtectedRoute;
